<template>
  <div class="floor-evaluate-result" v-if="evInfo">
    <!-- {{ evInfo }}/ -->
    <price-trend
      class="price-trend"
      :eva-info="evInfo"
      hsb-color="#fabe00"
      other-color="#CCCCCC"
      hsb-label="回收宝报价"
    >
      <template slot="title">
        <h3>价格趋势</h3>
      </template>
    </price-trend>
    <div class="price-msg">
      <h3>估价结果</h3>
      <div class="price">
        <span class="money">¥{{ evInfo.quotation / 100 }}</span>
        <span class="free-mailing"></span>
      </div>
      <p class="recovery-record">已有<span>{{ recycleNum }}</span>人成功收钱</p>
      <div class="price-forecast">
        <span>预计下月跌幅</span>
        <i class="line"></i>
        <strong>{{ evInfo.fallPrice / 100 || 0 }}元</strong>
      </div>
      <p>快看~价格走低，再不出手就亏了</p>
      <button class="button-initOrder" @click="toInitOrder">马上换钱</button>
      <ul class="activity">
        <li v-for="(item, index) in activityList" :key="index">
          <span>{{ item.activityName }}</span>
          <span class="activity-money">￥{{ item.couponMoney / 100 }}</span>
        </li>
      </ul>
      <p class="wechat-tip">想第一时间查看订单进展，可以关注“回收宝”微信公众号，还有送红包、手机活动等你参与</p>
      <div class="money-cost-box">
        <span>存到自己的小金库，积少成多。</span>
      </div>
    </div>
  </div>
</template>

<script>
import PriceTrend from '@/core/common-ui/price-trend/price-trend';
import { mapState } from 'vuex';
import { getRecycleNum } from '@/apis/base';

export default {
  components: {
    PriceTrend
  },
  computed: {
    ...mapState({
      evInfo: state => state.evaluate.info || {}
    }),
    evaluateid () {
      return this.$route.params.evID;
    },
    activeInfo () {
      return (this.evInfo.activityList && this.evInfo.activityList[0]) || {};
    },
    activityList () {
      return (this.evInfo.activityList && this.evInfo.activityList) || [];
    }
  },
  data () {
    return {
      disabled: false,
      recycleNum: 0
    };
  },
  methods: {
    toInitOrder () {
      this.disabled = true;
      this.$store.commit('report/reportHandle', { event: 'quickRecycle' });
      this.$router.push(`/initOrder/${this.evaluateid}`);
      setTimeout(() => {
        this.disabled = false;
      }, 3000);
    },
    async fetchRecycleNum () {
      try {
        const res = await getRecycleNum(this.evInfo.productId);
        if (res.success) {
          this.recycleNum = res._data.recycleNum;
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted () {
    if (this.evInfo.productId) {
      this.fetchRecycleNum();
    }
  }
};
</script>

<style lang="postcss" scoped>

.floor-evaluate-result {
  height: 420px;
  margin-bottom: 20px;

  /deep/ .hsb-price::after, /deep/ .hsb-price::before {
    background-color: #fabe00;
  }

  /deep/ .market-price::after, /deep/ .market-price::before {
    background-color: #ccc;
  }
}

h3 {
  font-size: 18px;
  line-height: 50px;
  padding-top: 20px;
  text-align: left;
  font-weight: 400;
}

.price-trend {
  float: left;
  width: 590px;
  height: 100%;
  background-color: #fff;
  /deep/ .chart-wrapper {
    height: 300px;
  }
  /deep/ .forecast {
    &::before {
      display: none;
    }
  }
  h3 {
    padding-left: 20px;
  }
}

.price-forecast {
  color: #333333;
  margin-top: 30px;
  line-height: 25px;
  font-size: 14px;
}

.button-initOrder {
  display: block;
  width: 260px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #ff5f43;
  border-radius: 2px;
  color: #ffffff;
  margin-top: 20px;
  outline: 0;
  border: 0;
  cursor: pointer;
}

.price-msg {
  position: relative;
  float: left;
  width: 610px;
  height: 100%;
  font-size: 16px;
  background-color: #fff;
  p {
    margin-top: 6px;
    font-size: 14px;
    line-height: 24px;
    color: #b9bdbf;
  }
  .price {
    position: relative;
    display: inline-block;
    margin-top: 10px;
  }
  .money {
    font-size: 48px;
    color: #ff5f43;
    padding-right: 5px;
  }
  .free-mailing {
    display: block;
    width: 66px;
    height: 26px;
    background: url(https://www.huishoubao.com/static/pc/1001/img/free-mailing.png) no-repeat center;
    position: absolute;
    top: 8px;
    left: 100%;
  }
  .recovery-record {
    font-size: 14px;
    margin-top: 8px;
    color: #b9bdbf;
  }
  .money-cost-box {
    width: 170px;
    height: 153px;
    position: absolute;
    left: 285px;
    top: 140px;
    background: url(https://www.huishoubao.com/static/pc/1001/img/logo-price.png) no-repeat center;
    span {
      display: block;
      width: 113px;
      margin: 38px auto;
      text-align: center;
    }
  }
  .activity {
    margin-top: 10px;
    font-size: 14px;
    line-height: 24px;
    color: #333;
  }
  .activity-money {
    color: #ff5f43;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/evInfo/floor-evaluate-result.vue